import classnames from 'classnames';
import MuiPagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import MenuItem from '@material-ui/core/MenuItem';
import {DEFAULT_TRANSACTIONS_OPTIONS, DEFAULT_PAGINATION_OPTIONS} from '@constants/index';
import useJoinMessage from '@hooks/useJoinMessage';
import {BaseSelect} from '@components/Core/inputs/BaseSelect/BaseSelect';
import './pagination.less';

export default function PagePagination({
    from,
    perPage,
    total,
    changePage,
    changePerPage,
    className,
    perPageOptions = DEFAULT_PAGINATION_OPTIONS,
    dataWdio = ''
}) {
    const joinMessage = useJoinMessage();
    const classNames = classnames('pagination', className);
    const pagesCount = Math.ceil(total / perPage);
    const currentpage = Math.ceil(from / perPage);
    const selectLabel = joinMessage('esl.generic.select_number_of_items_per_page');

    function onPageChange(e, page) {
        const newTo = page * perPage;
        const newFrom = newTo - perPage + 1;

        changePage({
            from: newFrom,
            to: newTo
        });
    }

    function onPerPageChange(e) {
        const newPerPage = e.target.value;

        const newTo = newPerPage;
        const newFrom = DEFAULT_TRANSACTIONS_OPTIONS.from;

        changePerPage(newPerPage);
        changePage({
            from: newFrom,
            to: newTo
        });
    }

    /** Optional: omitting `dataWdio` reproduces MUI's own default `renderItem` output exactly, so unset consumers are unaffected. */
    function getPageItemDataWdio(item) {
        if (!dataWdio) {
            return undefined;
        }
        return item.type === 'page' ? `${dataWdio}-page-${item.page}-btn` : `${dataWdio}-${item.type}-btn`;
    }

    return (
        <div className={classNames}>
            <BaseSelect
                value={perPage}
                onChange={onPerPageChange}
                inputProps={{'aria-label': selectLabel}}
                dataWdio={dataWdio ? `${dataWdio}-per-page-select` : undefined}
            >
                {Object.entries(perPageOptions).map(([key, value]) => (
                    <MenuItem key={key} value={value}>
                        {value}
                    </MenuItem>
                ))}
            </BaseSelect>
            <MuiPagination
                page={currentpage}
                count={pagesCount}
                onChange={onPageChange}
                size="small"
                showFirstButton
                showLastButton
                renderItem={(item) => <PaginationItem {...item} data-wdio={getPageItemDataWdio(item)} />}
            />
        </div>
    );
}
